// Matches React Query's own default, so that a failure this does retry waits
// exactly as long as it always has.
const MAX_RETRIES = 3

const CLIENT_ERROR_FLOOR = 400
const SERVER_ERROR_FLOOR = 500

// The two client errors that describe the attempt rather than the credential.
// Both say to come back, and the bootstrap has no other way to: it is fetched
// once per page load and neither remounting nor refocusing asks again.
const REQUEST_TIMEOUT = 408
const TOO_MANY_REQUESTS = 429


/**
 * Decides whether a failed attempt at the user record is worth another one.
 *
 * Nothing about the browser changes between attempts, so a refusal the server
 * has already made it will make again, and retrying one only postpones the
 * answer. A timeout, an offline tab or a 502 is the opposite: the request never
 * got an answer, and the next one may.
 *
 * @param {Number} failureCount - how many attempts have already failed
 * @param {Object} error - the error the last attempt rejected with
 *
 * @returns {Boolean} whether to attempt the request again
 */
export default function shouldRetry(failureCount, error) {
  if ( isRefusal(error) ) {
    return false
  }

  return failureCount < MAX_RETRIES
}

function isRefusal({ response }) {
  const status = response?.status

  if ( status === REQUEST_TIMEOUT || status === TOO_MANY_REQUESTS ) {
    return false
  }

  return ( status >= CLIENT_ERROR_FLOOR && status < SERVER_ERROR_FLOOR )
}
